import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';
import { getCMUploadedViewEndpoint } from '../../../common/endpoints';

export const fetchCMUploadedViewData = createApi(getCMUploadedViewEndpoint, 'GET');

const CMUploadedView = createSlice({
  name: 'CMUploadedView',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCMUploadedViewData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCMUploadedViewData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchCMUploadedViewData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default CMUploadedView.reducer;